import { SearchModel, DiagnosisTreanment } from '@nrwl/rx-models';

export interface State {
  areaImplants: any[];
  implantVolumes: any[];
  implantPlanes: any[];
  bmiData: any[];
  skinToneData: any[];
  diagnosis: DiagnosisTreanment[];
  treatments: DiagnosisTreanment[];
  surgeons: DiagnosisTreanment[];
  visitTypes: DiagnosisTreanment[];
  procedureTypes: DiagnosisTreanment[];
  bodyParts: any[];
  formTitle: { name: string; id: string }[];
  formProviders: any[];
  ordering: string;
  search: SearchModel;
  error: string;
}

export const initialState: State = {
  areaImplants: [],
  implantVolumes: [],
  implantPlanes: [],
  bmiData: [],
  skinToneData: [],
  diagnosis: [],
  treatments: [],
  surgeons: [],
  visitTypes: [],
  procedureTypes: [],
  bodyParts: [],
  formTitle: [],
  formProviders: [],
  ordering: '',
  search: new SearchModel(''),
  error: '',
};
